import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b46466d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-game-root" }
const _hoisted_2 = { class: "game-header" }
const _hoisted_3 = { class: "table-name" }
const _hoisted_4 = { class: "table-round" }
const _hoisted_5 = { class: "user-name" }
const _hoisted_6 = { class: "user-balance" }
const _hoisted_7 = {
  key: 0,
  class: "user-control-btns"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "value-btns" }, "换靴", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "value-btns" }, "飞牌", -1))
const _hoisted_10 = { class: "value-btns" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "value-btns" }, "小费", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "value-btns" }, "暂停", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "value-btns" }, "开牌", -1))
const _hoisted_14 = {
  key: 5,
  class: "btn-s"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fill" }, null, -1))
const _hoisted_16 = {
  key: 1,
  class: "display-mode-wrap"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "功能", -1))
const _hoisted_18 = { class: "content" }
const _hoisted_19 = { class: "video-and-bet-view-group" }
const _hoisted_20 = { class: "video-area-group" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("canvas", { id: "player1" }, null, -1))
const _hoisted_22 = {
  key: 0,
  class: "video-loader"
}
const _hoisted_23 = { class: "type-game-id" }
const _hoisted_24 = {
  key: 1,
  class: "is-reserved"
}
const _hoisted_25 = { class: "bet-view-group-others" }
const _hoisted_26 = { class: "road-summary-group" }
const _hoisted_27 = { class: "road-summary" }
const _hoisted_28 = ["data-label"]
const _hoisted_29 = ["data-label"]
const _hoisted_30 = {
  class: "road-map-summary-item",
  "data-color": "green",
  "data-label": "和"
}
const _hoisted_31 = {
  key: 0,
  class: "road-map-summary-item",
  "data-color": "red",
  "data-label": "对"
}
const _hoisted_32 = {
  key: 1,
  class: "road-map-summary-item",
  "data-color": "blue",
  "data-label": "对"
}
const _hoisted_33 = { class: "limit-info" }
const _hoisted_34 = { class: "limit-item" }
const _hoisted_35 = { class: "limit-item" }
const _hoisted_36 = {
  key: 0,
  class: "limit-item"
}
const _hoisted_37 = { class: "other-content" }
const _hoisted_38 = { class: "pre-group" }
const _hoisted_39 = { class: "footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_i_user_l = _resolveComponent("i-user-l")!
  const _component_i_balance = _resolveComponent("i-balance")!
  const _component_i_reload_g = _resolveComponent("i-reload-g")!
  const _component_i_card = _resolveComponent("i-card")!
  const _component_i_diamond = _resolveComponent("i-diamond")!
  const _component_i_balance_g = _resolveComponent("i-balance-g")!
  const _component_icon_pause_g = _resolveComponent("icon-pause-g")!
  const _component_icon_open_card_g = _resolveComponent("icon-open-card-g")!
  const _component_i_home = _resolveComponent("i-home")!
  const _component_i_full = _resolveComponent("i-full")!
  const _component_i_normal = _resolveComponent("i-normal")!
  const _component_i_arrow_h = _resolveComponent("i-arrow-h")!
  const _component_ctrl_bet_box_group = _resolveComponent("ctrl-bet-box-group")!
  const _component_ctrl_chips = _resolveComponent("ctrl-chips")!
  const _component_road_map = _resolveComponent("road-map")!
  const _component_d_prediction = _resolveComponent("d-prediction")!
  const _component_card_preview_result = _resolveComponent("card-preview-result")!
  const _component_card_game_result = _resolveComponent("card-game-result")!
  const _component_marquee_text = _resolveComponent("marquee-text")!
  const _component_switch_table = _resolveComponent("switch-table")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.tableName), 1),
      _createElementVNode("div", {
        class: _normalizeClass(["timer-count-down", _ctx.timerColor])
      }, _toDisplayString(_ctx.currentCount >= 0 ? _ctx.currentCount : ' 结算中 '), 3),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.t('shoeround')) + ":" + _toDisplayString(_ctx.shoeRound), 1),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_i_user_l, { class: "icon user-l" }),
        _createTextVNode(" " + _toDisplayString(_ctx.user), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_i_balance, { class: "icon balance" }),
        _createTextVNode(" " + _toDisplayString(_ctx.coin), 1)
      ]),
      (_ctx.showTableControls)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            (_ctx.userCommandType === 1)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "btn-s",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.callOperatStatus(1)), ["prevent"]))
                }, [
                  _createVNode(_component_i_reload_g, { class: "icon-btns" }),
                  _hoisted_8
                ]))
              : _createCommentVNode("", true),
            (_ctx.userCommandType === 1)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "btn-s",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.callFlyBet && _ctx.callFlyBet(...args)), ["prevent"]))
                }, [
                  _createVNode(_component_i_card, { class: "icon-btns" }),
                  _hoisted_9
                ]))
              : _createCommentVNode("", true),
            (_ctx.tableCanReserved)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  class: "btn-s",
                  onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.callReservedOrCancellReserved && _ctx.callReservedOrCancellReserved(...args)), ["prevent"]))
                }, [
                  _createVNode(_component_i_diamond, { class: "icon-btns" }),
                  _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.vipButtontext), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: "btn-s",
              onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.showTipBox && _ctx.showTipBox(...args)), ["prevent"]))
            }, [
              _createVNode(_component_i_balance_g, { class: "icon-btns" }),
              _hoisted_11
            ]),
            (_ctx.userCommandType === 2 && _ctx.isYoureReserved)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 3,
                  class: "btn-s",
                  onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.callPauseRequest && _ctx.callPauseRequest(...args)), ["prevent"]))
                }, [
                  _createVNode(_component_icon_pause_g, { class: "icon-btns" }),
                  _hoisted_12
                ]))
              : _createCommentVNode("", true),
            (
                        (_ctx.isYoureReserved &&
                            _ctx.enableOpenPokerOP &&
                            _ctx.enableOpenPoker) ||
                        (_ctx.userCommandType === 1 && _ctx.enableOpenPokerOP)
                    )
              ? (_openBlock(), _createElementBlock("div", {
                  key: 4,
                  class: "btn-s",
                  onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.callOpenPokeRequest && _ctx.callOpenPokeRequest(...args)), ["prevent"]))
                }, [
                  _createVNode(_component_icon_open_card_g, { class: "icon-btns" }),
                  _hoisted_13
                ]))
              : _createCommentVNode("", true),
            (_ctx.userCommandType === 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createElementVNode("div", {
                    class: "value-btns",
                    onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.callGunnerFunc && _ctx.callGunnerFunc(...args)), ["prevent"]))
                  }, _toDisplayString(_ctx.callGunnerText), 1)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _hoisted_15,
      _createVNode(_component_i_home, {
        class: "icon-home",
        onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.$router.push({ name: 'loby' })), ["prevent"]))
      }),
      (_ctx.fullScreenAvailable)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            (!_ctx.isfullScreen)
              ? (_openBlock(), _createBlock(_component_i_full, {
                  key: 0,
                  class: "icon full",
                  onClick: _withModifiers(_ctx.requestFullScreen, ["prevent"])
                }, null, 8, ["onClick"]))
              : (_openBlock(), _createBlock(_component_i_normal, {
                  key: 1,
                  class: "icon normal",
                  onClick: _withModifiers(_ctx.requestFullScreen, ["prevent"])
                }, null, 8, ["onClick"]))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "drop-down-setting",
        onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.showSettingDialog && _ctx.showSettingDialog(...args)))
      }, [
        _hoisted_17,
        _createVNode(_component_i_arrow_h, { class: "icon-arrow" })
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _hoisted_21,
          _createElementVNode("canvas", {
            id: "player2",
            class: _normalizeClass({ 'scale-video': _ctx.isScaleVideo })
          }, null, 2),
          (_ctx.isLoadingVideo)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.commandTypeAndGameId), 1),
          _createElementVNode("div", {
            class: "switch-table",
            onClick: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.hideSwitchTable && _ctx.hideSwitchTable(...args)), ["prevent"]))
          }, " 切换桌台 "),
          _createElementVNode("div", {
            class: _normalizeClass(["media-control-group", { disabled: _ctx.showMediaControl }])
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["icon-video", { on: _ctx.deskVideoOn }]),
              onClick: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onToggleVideo && _ctx.onToggleVideo(...args)), ["prevent"]))
            }, null, 2),
            _createElementVNode("div", {
              class: _normalizeClass(["icon-sound", { on: _ctx.soundIsOn }]),
              onClick: _cache[11] || (_cache[11] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleSoundEffect && _ctx.toggleSoundEffect(...args)), ["prevent"]))
            }, null, 2),
            _createElementVNode("div", {
              class: _normalizeClass(["icon-zoom", { on: _ctx.isScaleVideo }]),
              onClick: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (_ctx.isScaleVideo = !_ctx.isScaleVideo), ["prevent"]))
            }, null, 2),
            _createElementVNode("div", {
              class: _normalizeClass(["icon-arrow-toggle", { on: _ctx.showMediaControl }]),
              onClick: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (
                                _ctx.showMediaControl = !_ctx.showMediaControl
                            ), ["prevent"]))
            }, null, 2)
          ], 2),
          (_ctx.isReserved)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_25, [
          (_openBlock(), _createBlock(_component_ctrl_bet_box_group, {
            class: "bet-view-group",
            gameType: _ctx.gameType,
            mData: _ctx.gameTable,
            key: _ctx.betViewKey,
            ref: "refBetGroup",
            onOnUpdate: _ctx.onPlaceTempBetOrClear,
            onOnBetSuccess: _ctx.onBetSuccess
          }, null, 8, ["gameType", "mData", "onOnUpdate", "onOnBetSuccess"])),
          (_ctx.showChipControls)
            ? (_openBlock(), _createBlock(_component_ctrl_chips, {
                key: 0,
                class: "chips-group"
              }))
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "btn-join-table",
                onClick: _cache[14] || (_cache[14] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.joinTable && _ctx.joinTable(...args)), ["prevent"]))
              }, _toDisplayString(_ctx.btnJoinTableLabel), 1))
        ])
      ]),
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", {
            class: "road-map-summary-item",
            "data-color": "red",
            "data-label": _ctx.gameType === 'G002' ? '庄' : '龙'
          }, _toDisplayString(_ctx.redCount), 9, _hoisted_28),
          _createElementVNode("div", {
            class: "road-map-summary-item",
            "data-color": "blue",
            "data-label": _ctx.gameType === 'G002' ? '闲' : '虎'
          }, _toDisplayString(_ctx.blueCount), 9, _hoisted_29),
          _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.greenCount), 1),
          (_ctx.gameType === 'G002')
            ? (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(_ctx.redPairCount), 1))
            : _createCommentVNode("", true),
          (_ctx.gameType === 'G002')
            ? (_openBlock(), _createElementBlock("div", _hoisted_32, _toDisplayString(_ctx.bluePairCount), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.gameType === 'G002' ? '庄闲' : '龙虎') + "限红:" + _toDisplayString(_ctx.redBlueLimit), 1),
          _createElementVNode("div", _hoisted_35, "和限红:" + _toDisplayString(_ctx.greenLimit), 1),
          (_ctx.gameType === 'G002')
            ? (_openBlock(), _createElementBlock("div", _hoisted_36, " 对子限红:" + _toDisplayString(_ctx.pairLimit), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_37, [
      (_openBlock(), _createBlock(_component_road_map, {
        ref: "roadmapview1",
        class: "road-map",
        mapData: _ctx.mapData,
        key: _ctx.deskMapKey,
        enablePrediction: true,
        onRoadMapData: _ctx.onRoadMapDataParsed,
        onRoadResultPreview: _ctx.handleOnMapPreview,
        enableClicked: true,
        gameType: _ctx.gameType === 'G002' ? 1 : 2
      }, null, 8, ["mapData", "onRoadMapData", "onRoadResultPreview", "gameType"])),
      _createElementVNode("div", _hoisted_38, [
        _createVNode(_component_d_prediction, {
          class: "pre",
          gameType: _ctx.gameType === 'G002' ? 1 : 2,
          color: 1,
          mapdata: _ctx.nextRedRoadMapSummaryData,
          onClick: _cache[15] || (_cache[15] = _withModifiers(($event: any) => (_ctx.predict(1)), ["prevent"]))
        }, null, 8, ["gameType", "mapdata"]),
        _createVNode(_component_d_prediction, {
          class: "pre",
          gameType: _ctx.gameType === 'G002' ? 1 : 2,
          color: 2,
          mapdata: _ctx.nextBlueRoadMapSummaryData,
          onClick: _cache[16] || (_cache[16] = _withModifiers(($event: any) => (_ctx.predict(2)), ["prevent"]))
        }, null, 8, ["gameType", "mapdata"])
      ]),
      _createVNode(_Transition, { name: "fadein-out" }, {
        default: _withCtx(() => [
          (_ctx.showResultPreview)
            ? (_openBlock(), _createBlock(_component_card_preview_result, {
                key: 0,
                class: "card-preview",
                onClose: _cache[17] || (_cache[17] = ($event: any) => (_ctx.showResultPreview = false))
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (_ctx.showCardDisplay)
        ? (_openBlock(), _createBlock(_component_card_game_result, {
            class: "game-result",
            gameType: _ctx.gameType === 'G002' ? 1 : 2,
            info: _ctx.cardResultData,
            key: _ctx.cardResultKey
          }, null, 8, ["gameType", "info"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_39, [
      (_openBlock(), _createBlock(_component_marquee_text, {
        class: "notice",
        key: _ctx.deskNoticeKey
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.deskNotice), 1)
        ]),
        _: 1
      }))
    ]),
    _createVNode(_Transition, { name: "slide-right" }, {
      default: _withCtx(() => [
        (_ctx.showSwitchDesk)
          ? _withDirectives((_openBlock(), _createBlock(_component_switch_table, {
              key: 0,
              class: "switch-table",
              onEnterTable: _ctx.onSwitchTable
            }, null, 8, ["onEnterTable"])), [
              [_directive_click_outside, _ctx.hideSwitchTable]
            ])
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}